import { render, staticRenderFns } from "./plasticMachinery.vue?vue&type=template&id=543fbb56&scoped=true"
import script from "./plasticMachinery.vue?vue&type=script&lang=js"
export * from "./plasticMachinery.vue?vue&type=script&lang=js"
import style0 from "./plasticMachinery.vue?vue&type=style&index=0&id=543fbb56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543fbb56",
  null
  
)

export default component.exports